import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { ParentProgrammeGeneralDetails } from '../../../types/entity.types';
import {
  ArchiveProgrammeRequest,
  ArchiveProgrammeResponse,
  CreateProgrammeRequest,
  CreateProgrammeResponse,
  PublishProgrammeRequest,
  UpdateParentProgrammeRequest,
  UpdateSubProgrammeRequest,
  ViewParentProgrammeRequest,
  ViewSubProgrammeRequest
} from './programme.types';

import {
  requestArchiveProgramme,
  requestCreateProgramme,
  requestPublishProgramme,
  requestUpdateParentProgramme,
  requestUpdateSubProgramme,
  requestViewAllProgrammes,
  requestViewParentProgramme,
  requestViewSubProgramme
} from './programme.actions';

export const useV2ProgrammeApi = () => {
  const dispatch = useDispatch();

  const viewAllProgrammes = useCallback(() => {
    dispatch(requestViewAllProgrammes());
  }, [dispatch]);

  const createProgramme = useCallback(
    (requestData: CreateProgrammeRequest, onSuccess?: (data: CreateProgrammeResponse) => void) => {
      dispatch(requestCreateProgramme({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewParentProgramme = useCallback(
    (requestData: ViewParentProgrammeRequest, onSuccess?: (data: ParentProgrammeGeneralDetails) => void) => {
      dispatch(requestViewParentProgramme({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewSubProgramme = useCallback(
    (requestData: ViewSubProgrammeRequest) => {
      dispatch(requestViewSubProgramme({ requestData }));
    },
    [dispatch]
  );

  const updateParentProgramme = useCallback(
    (requestData: UpdateParentProgrammeRequest, onSuccess?: (data: { programmeExternalReference: string }) => void) => {
      dispatch(requestUpdateParentProgramme({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const updateSubProgramme = useCallback(
    (requestData: UpdateSubProgrammeRequest, onSuccess?: (data: { programmeExternalReference: string }) => void) => {
      dispatch(requestUpdateSubProgramme({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const publishProgramme = useCallback(
    (requestData: PublishProgrammeRequest, onSuccess?: (externalReference: string) => void) => {
      dispatch(requestPublishProgramme({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const archiveProgramme = useCallback(
    (requestData: ArchiveProgrammeRequest, onSuccess?: (data: ArchiveProgrammeResponse) => void) => {
      dispatch(requestArchiveProgramme({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return {
    viewAllProgrammes,
    createProgramme,
    viewParentProgramme,
    viewSubProgramme,
    updateParentProgramme,
    updateSubProgramme,
    publishProgramme,
    archiveProgramme
  };
};
